import { render } from "./batchPaySelectModel.vue?vue&type=template&id=3d773a44"
import script from "./batchPaySelectModel.vue?vue&type=script&lang=js"
export * from "./batchPaySelectModel.vue?vue&type=script&lang=js"

import "./batchPaySelectModel.vue?vue&type=style&index=0&id=3d773a44&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__